import { createAction, props } from '@ngrx/store'
import { AutomationProcessListAPIModel, ListExpenseAPIRequest, PaginatedAPI } from 'src/models/api.model'

const prefix = '[automation-process]'

export const FETCH_AUTOMATION_PROCESS_LIST = createAction(
  `${prefix} automation_process_list`,
  props<{ payload: ListExpenseAPIRequest }>()
)

export const FETCH_AUTOMATION_PROCESS_LIST_SUCCESS = createAction(
  `${prefix} automation_process_list_success`,
  props<{ automationRegisterList: PaginatedAPI<AutomationProcessListAPIModel> }>()
)

export const REPOST_FILE = createAction(
  `${prefix} repost_file`,
  props<{ id: string }>()
)
